import { Client } from "graphql-ws";

type Teardown = () => void;
type Setup = (client: Client) => Teardown;

interface Entry {
	setup: Setup;
	teardown: Teardown | null;
}

let sharedClient: Client | null = null;
const entries = new Map<string, Entry>();

const attach = (key: string) => {
	const client = sharedClient;
	const entry = entries.get(key);
	if (!client || !entry) return;

	entry.teardown?.();
	entry.teardown = entry.setup(client);
};

export const setSharedWsClient = (client: Client) => {
	sharedClient = client;
	for (const key of entries.keys()) attach(key);
};

export const clearSharedWsClient = (client: Client) => {
	if (sharedClient !== client) return;
	for (const entry of entries.values()) {
		entry.teardown?.();
		entry.teardown = null;
	}
	sharedClient = null;
};

export const registerSharedSubscription = (key: string, setup: Setup) => {
	const prev = entries.get(key);
	prev?.teardown?.();

	entries.set(key, { setup, teardown: null });
	attach(key);

	return () => {
		const entry = entries.get(key);
		if (!entry) return;
		entry.teardown?.();
		entries.delete(key);
	};
};
